import employeeSearchTagsComponent from './employeeSearchTags.component';

let employeeSearchTagsModule = angular.module('vacations-absences.employeeSearchTags', [])

.component('employeeSearchTags', employeeSearchTagsComponent)

.name;

export default employeeSearchTagsModule;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/components/employeeSearchTags/employeeSearchTags.js